import { Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconComponent } from '@shared/components/icon/icon.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { v4 as uuidv4 } from 'uuid';

export interface IBreadcrumb {
  label: string;
  link?: string;
  id?: string;
}

@Component({
  imports: [RouterModule, NgxSkeletonLoaderModule, IconComponent],
  selector: 'app-breadcrumb',
  styleUrls: ['./breadcrumb.component.scss'],
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  public readonly items = input.required<IBreadcrumb[]>();

  public readonly calculatedItems = computed(() => {
    return this.items().map((item) => ({
      id: item.id ?? uuidv4(),
      label: item.label,
      link: item.link,
    }));
  });

  public static readonly loadingLabel = '__loading__';
  public readonly loadingLabel = BreadcrumbComponent.loadingLabel;
}
